export const getPermissionType = (userType) => {
  if (userType === 'BUSINESS_INTELLIGENCE_SUPER_ADMIN') {
    return 'super_admin';
  }
  if (userType === 'BUSINESS_INTELLIGENCE_ADMIN') {
    return 'admin';
  }
  if (userType === 'BUSINESS_INTELLIGENCE_USER') {
    return 'user';
  }
  return 'user';
};
